/* eslint-disable no-alert */

AoPS.Utils.initKeyChain(AoPS, "Consultation", "Views");

AoPS.Consultation.Views = (function (Views) {
	Views.Utils = AoPS.View.extend({
		showLoadingModal: function () {
			var self = this;
			self.loadingModal = AoPS.Ui.Modal.showMessage(
				'<img src="/assets/images/logo-loader.gif" />',
				{
					closeX: false,
					force_response: true,
					frame_class: "loading-modal-frame",
				}
			);
		},
		closeLoadingModal: function () {
			if (this.loadingModal) {
				AoPS.Ui.Modal.closeParticularModal(this.loadingModal);
			}
		},
	});

	Views.MainView = AoPS.View.extend({
		className: "consult-request-main-view",
		events: {
			"click .student-list-entry": "changeCurrentStudent",
			"click .decline-schedule": "bypassScheduling",
		},
		initialize: function (options) {
			this.options = options;
			this.validate_opts = {
				update: this.model.get("view") === "update_form",
				update_single: this.model.get("update_single"),
			};
			this.model.on("change", _.debounce(_.bind(this.render, this), 128));
			this.render();

			AoPS.fixSidebarClassObserver();
		},
		render: function () {
			var view = this.model.get("view");
			switch (view) {
				case "request_form":
					this.renderRequestForm();
					break;
				case "additional_consult":
					this.renderAdditionalConsult();
					break;
				case "parent_has_account_error":
					this.renderParentAccountError();
					break;
				case "unknown_onsched_error":
					this.renderUnknownOnSchedError();
					break;
				case "show_schedule":
					this.renderSchedule();
					break;
				case "success_message":
				case "update_success_message":
				case "scheduling_success_message":
					this.renderRequestSuccess();
					break;
				case "update_form":
					this.renderRequestUpdate();
					break;
				case "hash_not_found":
					this.renderHashNotFound();
					break;
				case "scheduling_not_available":
					this.renderSchedulingNotAvailable();
					break;
			}
			$("#consultation-request").on("keydown", function (e) {
				var allowed_tags = ["TEXTAREA", "A", "BUTTON"];
				if (e.keyCode === 13 && allowed_tags.indexOf(e.target.tagName) < 0) {
					// prevent submit on enter
					// textarea, a, and button tags still allow the enter key
					e.preventDefault();
				}
			});
		},
		renderRequestForm: function () {
			var template_id = "#consult-request-tpl-main-view";
			var tpl_vars = {
				request_page_words: JSON.parse(AoPS.bd.request_page_words),
				referral_ended: this.model.get("referral_ended"),
				referral_ended_words: JSON.parse(AoPS.bd.referral_ended_words),
			};

			this.$el.html(this.getTemplate(template_id, tpl_vars));
			this.$inner = this.$("#request-form-container");
			var form_view = new Views.RequestFormView({
				model: this.model,
			});
			form_view.$el.appendTo(this.$inner);
		},
		renderAdditionalConsult: function () {
			var template_id = "#consult-request-tpl-main-view";
			var tpl_vars = {
				request_page_words: JSON.parse(AoPS.bd.request_page_words),
				referral_ended: this.model.get("referral_ended"),
				referral_ended_words: JSON.parse(AoPS.bd.referral_ended_words),
			};

			this.$el.html(this.getTemplate(template_id, tpl_vars));
			this.$inner = this.$("#request-form-container");
			var form_view = new Views.AdditionalRequestFormView({
				model: this.model,
			});
			form_view.$el.appendTo(this.$inner);
		},
		renderParentAccountError: function () {
			var template_id = "#consult-request-tpl-parent-has-account";
			var tpl_vars = {
				email: this.model.get("existing_account_email"),
				campus: this.model.get("campus"),
			};
			this.$el.html(this.getTemplate(template_id, tpl_vars));
		},
		renderUnknownOnSchedError: function () {
			var template_id = "#consult-request-tpl-onsched-unknown-error";
			this.$el.html(
				this.getTemplate(template_id, {campus_id: AoPS.bd.campus.id})
			);
			AoPS.Ui.Modal.closeAllModals();
		},
		renderHashNotFound: function () {
			var template_id = "#consult-request-tpl-hash-not-found";
			var tpl_vars = {
				campus: this.model.get("campus"),
			};
			this.$el.html(this.getTemplate(template_id, tpl_vars));
		},
		renderSchedulingNotAvailable: function () {
			var template_id = "#consult-request-tpl-scheduling-not-available";
			var tpl_vars = {
				campus: this.model.get("campus"),
			};
			this.$el.html(this.getTemplate(template_id, tpl_vars));
		},
		renderRequestSuccess: function () {
			var view = this.model.get("view");
			var template_id = "#consult-request-tpl-request-success";
			if (view === "update_success_message") {
				template_id = "#consult-request-tpl-update-success";
			} else if (view === "scheduling_success_message") {
				template_id = "#consult-request-tpl-request-scheduled-success";
			}
			var tpl_vars = {
				multi_students: this.model.get("students").length > 1,
				hash: this.model.get("hash"),
				can_update_students:
					this.model.get("is_post_request") || this.model.get("can_update"),
			};
			this.$el.html(this.getTemplate(template_id, tpl_vars));
		},
		renderSchedule: function () {
			var template_id = "#consult-request-tpl-show-schedule";

			this.listenTo(this.model, "refreshSchedule", this.renderSchedule);

			var tpl_vars = {
				is_post_request: this.model.get("is_post_request"),
				is_staff: this.model.get("is_staff"),
				can_go_back: this.model.get("can_go_back"),
				can_go_forward: this.model.get("can_go_forward"),
			};

			this.$el.html(this.getTemplate(template_id, tpl_vars));
			var $inner = this.$("#schedule-container");
			$inner.empty();

			this.model
				.get("schedule")
				.get("days")
				.each(function (day) {
					var schedule_view = new Views.ScheduleDayView({
						model: day,
						master: this.model,
					});
					$inner.append(schedule_view.$el);
				}, this);
		},
		renderRequestUpdate: function () {
			var tpl_vars = {
				update_single: this.model.get("update_single"),
				multi_students: this.model.get("students").length > 1,
				staff_mode: this.model.get("staff_mode"),
			};

			if (!tpl_vars.update_single) {
				// only need parent data for full update
				tpl_vars.parent_first = this.model
					.get("parents")
					.first()
					.get("first_name")
					.get("value");
			} else {
				var this_student = this.model.get("students").first();
				tpl_vars.first_name = this_student.get("first_name").get("value");
			}

			var template_id = "#consult-request-tpl-request-update";
			this.$el.html(this.getTemplate(template_id, tpl_vars));
			this.$inner = this.$("#update-form-container");
			var form_view = new Views.UpdateFormView({
				model: this.model,
			});
			form_view.$el.appendTo(this.$inner);
			if (this.model.get("should_scroll_on_render")) {
				var offset = $("#update-form-container").offset().top;
				$("html, body").animate(
					{
						scrollTop: offset,
					},
					2000
				);
				this.model.set("should_scroll_on_render", false);
			}
		},
		changeCurrentStudent: function (e) {
			e.preventDefault();
			var new_index = $(e.currentTarget).data("index");
			this.model.set("current_student_index", new_index);
			this.model.set("should_scroll_on_render", true);
		},
		bypassScheduling: function (e) {
			e.preventDefault();
			this.model.set("view", "success_message");
		},
	});

	Views.RequestFormView = Views.Utils.extend({
		template_id: "#consult-request-tpl-request-form",
		className: "consult-request-form",
		events: {
			"click #add-student": "addStudent",
			"click #add-parent": "addParent",
			"change .input": "updateModel",
			"click #submit-request-btn": "submitRequest",
		},
		initialize: function (options) {
			this.options = options;
			this.validate_opts = {
				update: false,
				update_single: false,
			};
			this.model.on("change", _.debounce(_.bind(this.onChange, this), 128));
			this.prerenderHelper();
			this.render();
		},
		prerenderHelper: function () {
			// listen to parents collection for changes
			this.parents = this.model.get("parents");
			this.parents.on(
				"add remove reset sort",
				_.debounce(_.bind(this.renderParents, this), 128)
			);

			// listen to students collection for changes
			this.students = this.model.get("students");
			this.students.on(
				"add remove reset sort",
				_.debounce(_.bind(this.renderStudents, this), 128)
			);

			this.tpl_vars = {
				"allow-multi": this.model.get("allow_multi_parents"),
				email_consent: this.model.get("email_consent"),
				request_additional_info: this.model.get("request_additional_info"),
				multi: this.students.length > 1,
				has_errors: this.model.get("has_errors"),
				has_students: this.students.length > 0,
				hideParents: AoPS.bd.is_logged_in_and_initialized,
			};
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
			this.renderParents();
			this.renderStudents();
			this.renderReferrer();
		},
		renderParents: function () {
			this.$parent_container = this.$("#parent-rows");
			this.$parent_container.empty();
			if (!this.parents.length) {
				this.model.createParent();
			} else {
				this.parents.each(
					_.bind(function (parent, index) {
						var view = new Views.RequestParentForm({
							model: parent,
							master: this.model,
							index: index + 1, // make it 1-indexed
							multi: this.parents.length > 1,
						});
						this.$parent_container.append(view.$el);
					}, this)
				);
			}
		},
		renderStudents: function () {
			// This part and the renderStudents function in
			// Views.AdditionalRequestForm need lots of refactoring. But
			// consult flow getting rebuilt, so bandaid-ing in changes
			// needed for Platform for now.
			this.$student_container = this.$("#student-rows");
			this.$student_container.empty();
			if (!this.students.length) {
				this.model.createStudent();
			} else {
				// Pulls grade levels from AcademyTemplate through php to ensure consistent naming across AoPS
				this.students.each((student, index) => {
					var view;

					if (student.get("platform_user_id").get("value")) {
						// Could be initialized or uninitialized student
						view = new Views.AdditionalRequestStudentForm({
							model: student,
							master: this.model,
						});
					} else {
						// Completely new student
						view = new Views.RequestStudentForm({
							model: student,
							master: this.model,
							index: index + 1, // make it 1-indexed
							multi: this.students.length > 1,
						});
					}
					this.$student_container.append(view.$el);
				});
			}
		},
		renderReferrer: function () {
			if (this.model.get("referrer") !== null) {
				this.$referrer_container = this.$("#referrer-row");
				this.$referrer_container.empty();
				var view = new Views.RequestReferrerForm({
					model: this.model.get("referrer"),
					master: this.model,
				});
				this.$referrer_container.append(view.$el);
			} else {
				this.$("#referrer-section").empty();
			}
		},
		onChange: function () {
			this.prerenderHelper();
			this.render();
		},
		addStudent: function (e) {
			e.preventDefault();
			this.model.createStudent();
		},
		addParent: function (e) {
			e.preventDefault();
			var created = this.model.createParent();
			if (!created) {
				AoPS.Ui.Flyout.queue("Cannot create another parent.", {
					time: 2000,
					animation_time: 500,
				});
			}
		},
		updateModel: function (e) {
			var field_name = e.currentTarget.name;
			switch (field_name) {
				case "request-additional-info":
					this.model.set("request_additional_info", e.currentTarget.value);
					break;
				case "email-consent":
					this.model.set("email_consent", $("#email-consent").prop("checked"));
					break;
			}
		},
		submitRequest: function (e) {
			e.preventDefault();
			// validate
			this.showLoadingModal();
			this.model.validateColl("parents", this.validate_opts);
			this.model.validateColl("students", this.validate_opts);
			this.model.set("email_consent", $("#email-consent").prop("checked"));
			if (this.model.get("referrer") !== null) {
				this.model.validateSingle("referrer", this.validate_opts);
			}
			const selectedStudents = this.model.getSelectedStudents();
			const newStudents = this.model
				.get("students")
				.filter(
					(s) =>
						!(
							s.get("platform_user_id") &&
							s.get("platform_user_id").get("value")
						)
				);
			if (!selectedStudents.length && !newStudents.length) {
				this.model.set("has_errors", true);
				this.closeLoadingModal();
				AoPS.Ui.Flyout.queue("Please select a student to continue.");
			} else if (!this.model.get("has_errors")) {
				this.model.submitRequest(
					_.bind(this.closeLoadingModal, this),
					this.model.getSelectedStudents()
				);
			} else {
				this.closeLoadingModal();
			}
			window.scrollTo(0, 0);
		},
	});

	Views.AdditionalRequestFormView = Views.Utils.extend({
		template_id: "#consult-request-tpl-additional-request-form",
		className: "consult-request-form",
		events: {
			"change .input": "updateModel",
			"click #submit-request-btn": "submitRequest",
		},
		initialize: function (options) {
			this.options = options;
			this.validate_opts = {
				update: false,
				update_single: false,
			};
			this.model.on("change", _.debounce(_.bind(this.onChange, this), 128));
			this.prerenderHelper();
			this.render();
		},
		prerenderHelper: function () {
			// listen to students collection for changes
			this.students = this.model.get("students");
			this.students.on(
				"add remove reset sort",
				_.debounce(_.bind(this.renderStudents, this), 128)
			);
			this.parents = this.model.get("parents");

			this.tpl_vars = {
				"allow-multi": this.model.get("allow_multi_parents"),
				email_consent: this.model.get("email_consent"),
				request_additional_info: this.model.get("request_additional_info"),
				has_errors: this.model.get("has_errors"),
			};
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
			this.renderStudents();
		},
		renderStudents: function () {
			this.$student_container = this.$("#student-rows");
			this.$student_container.empty();

			if (!this.students.length) {
				this.model.createStudent();
			} else {
				this.students.each((student, index) => {
					var view;
					if (student.get("platform_user_id").get("value")) {
						// Could be initialized or uninitialized student
						view = new Views.AdditionalRequestStudentForm({
							model: student,
							master: this.model,
						});
					} else {
						// We should never be in this case. If initialized parent
						// with no students, they should be put to the mode =
						// 'new' flow
						view = new Views.RequestStudentForm({
							model: student,
							master: this.model,
							index: index + 1, // make it 1-indexed
							multi: this.students.length > 1,
						});
					}
					this.$student_container.append(view.$el);
				});
			}
		},
		onChange: function () {
			this.prerenderHelper();
			this.render();
		},
		updateModel: function (e) {
			var field_name = e.currentTarget.name;
			switch (field_name) {
				case "request-additional-info":
					this.model.set("request_additional_info", e.currentTarget.value);
					break;
				case "email-consent":
					this.model.set("email_consent", $("#email-consent").prop("checked"));
					break;
			}
		},
		submitRequest: function (e) {
			e.preventDefault();
			// validate
			this.showLoadingModal();
			// this.model.selected_student_ids used to keep track of which
			// students the parent wants a consultation for if there aren't
			// any, we shouldn't be able to submit request.
			if (!this.model.selected_student_ids) {
				this.model.set("has_errors", true);
				this.closeLoadingModal();
				AoPS.Ui.Flyout.queue("Please select a student to continue.");
			} else {
				// Allows submission if no selected student has errors
				if (!this.model.has_errors) {
					this.model.submitRequest(
						_.bind(this.closeLoadingModal, this),
						this.model.getSelectedStudents()
					);
				} else {
					this.closeLoadingModal();
				}
			}
		},
	});

	Views.RequestPersonForm = AoPS.View.extend({
		initialize: function (options) {
			this.options = options;
			this.master = this.options.master;
			this.validate_opts = {
				update: this.model.get("view") === "update_form",
				update_single: this.model.get("update_single"),
			};
			this.model.on("change", _.debounce(_.bind(this.onChange, this), 128));
			this.constructVars();
			this.render();
		},
		constructVars: function () {
			this.changed = false;
			this.blurs = 0;
			this.initTplVars();
			this.prerenderHelper();
			this.captureAttrVars();
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
			this.postRenderHelper();
		},
		initTplVars: function () {
			this.tpl_vars = {
				has_errors: this.model.get("has_errors"),
				field_errors: {},
			};
		},
		captureAttrVars: function () {
			var errors = [];
			_.each(
				this.model.attribute_keys,
				function (key) {
					var attr_model = this.model.get(key);
					this.tpl_vars[key] = attr_model.get("value");
					this.tpl_vars.field_errors[key] = attr_model.get("has_errors");
					errors = errors.concat(attr_model.get("errors"));
				},
				this
			);
			this.tpl_vars.errors = errors;
			this.postCaptureHelper();
		},
		prerenderHelper: function () {
			// noop in parent class
		},
		postCaptureHelper: function () {
			// noop in this base class.
			// overriding this will allow
			// manipulation of tpl_vars
			// before render.  Useful for
			// making things "prettier"
			// for display
		},
		postRenderHelper: function () {
			// noop here, can be overriden by children
		},
		onChange: function () {
			this.constructVars();
			var focused_id;
			// needs setTimeout because otherwise
			// it invariably triggers during the
			// ms that the document has focus
			// between fields.
			setTimeout(
				_.bind(function () {
					var focused_field = this.getFocusedField();
					focused_id = "#" + focused_field.attr("id");
					this.render();
					this.$(focused_id).focus();
				}, this),
				1
			);
		},
		updateModel: function (e) {
			var field_name = this.stripNameIndex(e.currentTarget.name);
			var value = e.currentTarget.value;
			var key = this.getKeyFromFieldName(field_name);
			if (key) {
				if (key === "interests") {
					var checked = this.$(".student-interest:checked");
					value = [];
					_.each(checked, (el) => {
						value.push($(el).val());
					});
				}
				if (key === "use_first_ec" || key === "tos_confirm") {
					value = e.currentTarget.checked;
				}
				if (["dob_month", "dob_day", "dob_year"].indexOf(key) >= 0) {
					var type = key.split("_")[1];
					this.model.setBirthdayAttr(type, value);
				} else {
					this.model.setAttr(key, value);
					if (key === "school_id") {
						// also need to set school name
						var school_name = null;
						if (value !== "other") {
							var school = this.master.get("school_data").get(value);
							if (school) {
								school_name = school.get("label");
							}
						} else {
							school_name = e.currentTarget.selectedOptions[0].text;
						}
						this.model.setAttr("school_name", school_name);
					}
				}
			} else {
				AoPS.Ui.Flyout.queue(
					"Something unexpected happened.  If this continues to happen, please contact tech support."
				);
			}
		},
		updateCanSubmit: function () {
			this.master.validateColl("students");
		},
		getKeyFromFieldName: function (field_name) {
			var key = field_name;

			switch (field_name) {
				case "parent-first":
				case "student-first":
					key = "first_name";
					break;
				case "parent-last":
				case "student-last":
					key = "last_name";
					break;
				case "student-gender":
					key = "gender";
					break;
				case "parent-email":
				case "email":
					key = "email_address";
					break;
				case "parent-phone":
					key = "phone_number";
					break;
				case "student-grade":
					key = "grade";
					break;
				case "student-interest-math":
				case "student-interest-science":
				case "student-interest-la":
					key = "interests";
					break;
				case "student-course":
					key = "course";
					break;
				case "student-additional-info":
					key = "additional_info";
					break;
				case "ec-name":
					key = "emergency_name";
					break;
				case "ec-phone":
					key = "emergency_phone";
					break;
				case "ec-relationship":
					key = "emergency_relationship";
					break;
				case "local-school":
					key = "school_id";
					break;
				default:
					key = key.replace(/-/g, "_");
			}
			return key;
		},
		getFocusedField: function () {
			var focused = this.$(".input:focus");
			if (focused.length) {
				return focused;
			}
			// check and see if we are focused on
			// a select2 thingy
			focused = this.$(".select2-selection:focus");
			return focused;
		},
		stripNameIndex: function (input) {
			// I hate that I have to do this, but bandaids everywhere.
			// Platform user IDs have "-" in them, so we need to use another
			// split symbol.
			var splitted;
			if (input.includes("+")) {
				splitted = input.split("+");
				if (splitted.length < 2) {
					// no index to strip;
					return input;
				}
				splitted.pop();
				return splitted[0];
			} else {
				splitted = input.split("-");
				if (splitted.length < 2) {
					// no index to strip;
					return input;
				}
				splitted.pop();
				return splitted.join("-");
			}
		},
	});

	Views.RequestParentForm = Views.RequestPersonForm.extend({
		template_id: "#consult-request-tpl-parent-request-row",
		className: "consult-parent",
		events: {
			"click .delete-parent": "deleteParent",
			"change .input": "updateModel",
		},
		prerenderHelper: function () {
			var parent_form_vars = {
				index: this.options.index,
				multi: this.options.multi,
				hideEmail:
					AoPS.bd.platform_user_info && !!AoPS.bd.platform_user_info.email,
			};
			_.extend(this.tpl_vars, parent_form_vars);
		},
		deleteParent: function (e) {
			e.preventDefault();
			this.model.destroy();
		},
	});

	Views.RequestStudentForm = Views.RequestPersonForm.extend({
		template_id: "#consult-request-tpl-student-request-row",
		className: "consult-student",
		events: {
			"click .delete-student": "deleteStudent",
			"change .input": "updateModel",
			"keydown .delete-student": "deleteStudent",
			"click .submit-student-req": "submitAdditionalRequest",
		},
		// Before rendering, creates the options for student grade and interests
		prerenderHelper: function () {
			var student_form_vars = {
				"grade-levels": this.model.getParsedGrade(),
				"student-interests": this.model.getParsedInterests(),
				index: this.options.index,
				multi: this.options.multi,
				season: this.master.get("season"),
			};
			_.extend(this.tpl_vars, student_form_vars);
		},
		deleteStudent: function (e) {
			e.preventDefault();
			if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
				this.model.destroy();
			}
		},
	});
	Views.AdditionalRequestStudentForm = Views.RequestPersonForm.extend({
		template_id: "#consult-request-tpl-additional-student-request-row",
		className: "consult-student",
		events: {
			"change .input": "updateModel",
			"change .student-consultation": "toggleStudentConsultation",
		},
		prerenderHelper: function () {
			var platform_user_id = this.model.get("platform_user_id").get("value");

			var selected = false;
			if (
				this.master.selected_student_ids &&
				this.master.selected_student_ids.includes(platform_user_id)
			) {
				selected = true;
			}

			var has_errors = this.model.get("has_errors");
			var errors = this.model.get("errors");
			errors = errors ? errors.get("value") : [];

			var display_name = this.model.get("display_name").get("value");
			var display_username = this.model.get("display_username").get("value");

			var student_name = display_username;
			if (display_name) {
				student_name += " (" + display_name + ")";
			}

			this.tpl_vars = {
				season: this.master.get("season"),
				"grade-levels": this.model.getParsedGrade(),
				"student-interests": this.model.getParsedInterests(),
				field_errors: {},
				platform_user_id,
				initialized: !!this.model.get("account_id").get("value"),
				first_name: this.model.get("first_name").get("value"),
				student_name,
				selected,
				has_errors,
				errors,
			};
		},
		// we store which students should be included in the consultation request
		// by adding them to this.master.selected_student_ids
		toggleStudentConsultation: function () {
			var platform_user_id = this.model.get("platform_user_id").get("value");
			var is_checked = $("#chk-" + platform_user_id).is(":checked");
			this.master.updateSelectedStudents(platform_user_id, is_checked);
			if (is_checked) {
				$(`.additional-request-hidable-${platform_user_id}`).removeClass(
					"additional-request-hidden"
				);
			} else {
				$(`.additional-request-hidable-${platform_user_id}`).addClass(
					"additional-request-hidden"
				);
			}
			this.updateCanSubmit();
		},
	});
	Views.RequestReferrerForm = Views.RequestPersonForm.extend({
		template_id: "#consult-request-tpl-referrer-request-row",
		className: "consult-referrer",
		events: {
			"change .input": "updateModel",
		},
	});

	Views.UpdateFormView = Views.Utils.extend({
		template_id: "#consult-request-tpl-request-update-form",
		className: "request-update-form",
		events: {
			"change .input": "updateModel",
			"click #submit-update": "submitUpdate",
		},
		initialize: function (options) {
			this.options = options;
			this.validate_opts = {
				update: true,
				update_single: this.model.get("update_single"),
			};
			this.model.on("change", _.debounce(_.bind(this.onChange, this), 128));
			this.prerenderHelper();
			this.render();
		},
		prerenderHelper: function () {
			this.tpl_vars = {
				update_single: this.validate_opts.update_single,
				has_errors: this.model.get("has_errors"),
			};
		},
		render: function () {
			if (this.loadingModal) {
				this.closeLoadingModal();
				this.loadingModal = false;
				if (this.model.get("has_errors")) {
					AoPS.Ui.Modal.showAlert(
						"There was a problem with your submission - please see the error(s) at the top of the form."
					);
				}
			}
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
			this.$student_container = this.$("#student-update-form-container");
			var first_student_name = this.model
				.get("students")
				.first()
				.get("first_name")
				.get("value");
			this.model.get("students").each(
				_.bind(function (student, index) {
					var vars = {
						model: student,
						master: this.model,
						index: index + 1,
						first_student_name: first_student_name,
					};
					var view = new Views.StudentUpdateFormView(vars);
					this.$student_container.append(view.$el);
				}, this)
			);
		},
		onChange: function () {
			this.prerenderHelper();
			this.render();
		},
		submitUpdate: function (e) {
			e.preventDefault();
			this.model.validateColl("students", this.validate_opts);
			if (!this.model.get("has_errors")) {
				this.showLoadingModal();
				if (this.model.get("update_single")) {
					this.model.completeProfile();
				} else {
					this.model.submitUpdate();
				}
			}
		},
	});

	Views.StudentUpdateFormView = Views.RequestPersonForm.extend({
		template_id: "#consult-request-tpl-update-student-form",
		className: "student-update-form",
		events: {
			"change .input": "updateModel",
		},
		prerenderHelper: function () {
			var year, month, day;

			this.tpl_vars.first_name = this.model.get("first_name").get("value");
			this.tpl_vars.index = this.options.index;
			this.tpl_vars.first_student = this.options.index === 1;
			this.tpl_vars.first_student_name = this.options.first_student_name;
			this.tpl_vars.season = this.master.get("season");
			this.tpl_vars.multi_students = this.master.get("students").length > 1;
			this.tpl_vars.update_single = this.master.get("update_single");
			this.tpl_vars.update_multi = !this.tpl_vars.update_single;
			this.tpl_vars.birthday = this.model.get("birthday").get("value");
			if (this.tpl_vars.birthday && this.tpl_vars.birthday.date) {
				[year, month, day] = this.tpl_vars.birthday.date.split("-");
				day = parseInt(day);
				month = parseInt(month);
				year = parseInt(year);
			}

			var month_data = this.model.get("birth_month_data");
			if (month_data[0].value) {
				if (this.model.get("selected_birth_month")) {
					month_data.unshift({
						value: 0,
						label: "Month",
						options: "disabled",
					});
				} else {
					month_data.unshift({
						value: 0,
						label: "Month",
						options: "disabled selected",
					});
				}
			}
			if (month && month_data[month]) {
				month_data[month].selected = true;
			}
			this.tpl_vars.months = month_data;

			var day_data = this.model.get("birth_day_data");
			if (day_data[0].value) {
				if (this.model.get("selected_birth_day")) {
					day_data.unshift({
						value: 0,
						label: "Day",
						options: "disabled",
					});
				} else {
					day_data.unshift({
						value: 0,
						label: "Day",
						options: "disabled selected",
					});
				}
			}
			if (day && day_data[day]) {
				day_data[day].selected = true;
			}
			this.tpl_vars.days = day_data;

			var year_data = this.model.get("birth_year_data");
			if (year_data[0].value) {
				if (this.model.get("selected_birth_year")) {
					year_data.unshift({
						value: 0,
						label: "Year",
						options: "disabled",
					});
				} else {
					year_data.unshift({
						value: 0,
						label: "Year",
						options: "disabled selected",
					});
				}
			}

			if (year) {
				_.each(year_data, function (data) {
					if (data.value === year) {
						data.selected = true;
					}
				});
			}
			this.tpl_vars.years = year_data;

			var school_data = [];
			var current_id = this.model.get("school_id").get("value");
			this.master.get("school_data").each(function (school) {
				if (Number(school.get("value")) === current_id) {
					school.set("selected", true);
				} else {
					school.set("selected", false);
				}
				school_data.push(school.attributes);
			}, this);
			if (current_id === "other") {
				school_data.push({
					value: "other",
					label: this.model.get("school_name").get("value"),
					selected: true,
				});
			}
			this.tpl_vars.schools = school_data;
		},
		postCaptureHelper: function () {
			// add some tpl_vars to help display the gender radio buttons
			this.tpl_vars.gender_m = false;
			this.tpl_vars.gender_f = false;
			this.tpl_vars.gender_o = false;
			this.tpl_vars.gender_u = false;
			var gender_string = "gender_" + this.tpl_vars.gender;
			this.tpl_vars[gender_string] = true;

			this.tpl_vars.show_ec =
				this.tpl_vars.first_student || !this.tpl_vars.use_first_ec;
		},
		postRenderHelper: function () {
			setTimeout(
				_.bind(function () {
					// inside set timeout because
					// postRenderHelper fires before
					// render is complete
					$(".local-school-select").select2({
						placeholder: "School",
						width: "resolve",
						allowClear: true,
						tags: true,
						createTag: function (params) {
							var term = $.trim(params.term);

							if (term === "") {
								return null;
							}

							return {
								id: "other",
								text: term,
								other: true,
							};
						},
					});
				}, this),
				0
			);
		},
	});

	Views.ScheduleDayView = Views.Utils.extend({
		template_id: "#consult-request-tpl-schedule-day",
		events: {
			"click .day-header": "onClickDayHeader",
		},
		initialize: function (options) {
			this.options = options;
			this.model = this.options.model;
			this.master = this.options.master;
			this.open = false;
			this.numOpenings = this.model.get("openings").length;
			this.available = this.numOpenings > 0;
			this.render();
		},
		prerenderHelper: function () {
			const thisDate = new moment(this.model.get("date"));
			this.tpl_vars = {
				available: this.available,
				open: this.open,
				day_name: thisDate.format("dddd"),
				availability: this.available
					? this.numOpenings + " appointments available"
					: "not available",
				day_date: thisDate.format("MMM D"),
			};
		},
		render: function () {
			this.prerenderHelper();
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
			if (this.open) {
				var $inner = this.$(".day-opening-container");
				$inner.empty();
				this.model.get("openings").each(function (opening) {
					var view = new Views.ScheduleOpeningView({
						model: opening,
						day: this.model,
						master: this.master,
					});
					$inner.append(view.$el);
				}, this);
			}
		},
		onClickDayHeader: function (e) {
			if (this.available) {
				this.open = !this.open;
				this.render();
			}
		},
	});

	Views.ScheduleOpeningView = Views.Utils.extend({
		template_id: "#consult-request-tpl-schedule-opening",
		className: "schedule-opening-container",
		events: {
			"click .schedule-opening": "onClickScheduleOpening",
		},
		initialize: function (options) {
			this.options = options;
			this.model = this.options.model;
			this.day = this.options.day;
			this.master = this.options.master;
			this.prerenderHelper();
			this.render();
		},
		prerenderHelper: function () {
			this.tpl_vars = {
				start_time: this.model.get("displayTime"),
				duration: moment
					.duration(this.model.get("duration"), "minutes")
					.humanize(),
			};
		},
		render: function () {
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
		},
		onClickScheduleOpening: function (e) {
			var self = this;
			var modal_contents = new Views.ScheduleConfirmation(this.options);
			AoPS.Ui.Modal.showConfirm(
				modal_contents.$el,
				function (ok) {
					AoPS.Ui.Modal.closeTopModal();
					if (!ok) {
						return;
					}
					self.showLoadingModal();
					self.master.scheduleAppointment(self.model, function (data) {
						AoPS.Ui.Modal.closeTopModal();
						if (!data.response.success) {
							self.closeLoadingModal();
							AoPS.Ui.Modal.showAlert(
								"We're sorry.  The appointment you selected is no longer available.  Please select another option."
							);
						} else {
							self.master.set("view", "scheduling_success_message");
						}
					});
				},
				{
					close_on_button_click: false,
					force_response: true,
				}
			);
		},
	});

	Views.ScheduleConfirmation = Views.Utils.extend({
		template_id: "#consult-request-tpl-schedule-confirm",
		initialize: function (options) {
			this.options = options;
			this.model = this.options.model;
			this.day = this.options.day;
			this.master = this.options.master;
			this.render();
		},
		prerenderHelper: function () {
			var currentMoment = this.model.get("moment");
			var duration = moment
				.duration(this.model.get("duration"), "minutes")
				.asHours();
			if (duration !== 1) {
				duration += " hours";
			} else {
				duration += " hour";
			}
			this.tpl_vars = {
				header_date: currentMoment.format("dddd, MMMM Do"),
				body_date: currentMoment.format("MMM D, YYYY"),
				body_time: this.model.get("displayTime"),
				body_duration: duration,
			};
		},
		render: function () {
			this.prerenderHelper();
			this.$el.html(this.getTemplate(this.template_id, this.tpl_vars));
		},
	});
	return Views;
})(AoPS.Consultation.Views);
